import { CurrencyPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
//---------------------------------------------------------------------------------------
import { MealPlan, MealPlanType } from 'src/app/models';

@Pipe({ name: 'mealPlanBalance' })
export class MealPlanBalancePipe implements PipeTransform {
  private currencyPipe: CurrencyPipe;

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.currencyPipe = new CurrencyPipe(this.locale);
  }

  transform(mealPlan: MealPlan): string {
    if (!mealPlan) {
      return '0';
    }

    if (mealPlan.tender_type) {
      // It should be remaining balance instead of balance used
      const remainingBalance = mealPlan.balance || 0;

      switch (mealPlan.tender_type) {
        case MealPlanType.UNLIMITED:
          return 'Unlimited';
        case MealPlanType.DECLINING_BALANCE:
          return this.currencyPipe.transform(remainingBalance);
        case MealPlanType.POINTS:
          return `${remainingBalance} ${
            remainingBalance > 1 ? 'Points' : 'Point'
          }`;
      }
    }
    return '';
  }
}
